import React, { createRef } from "react";
import PropTypes from "prop-types";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

import BrandService from "services/BrandService";

/**
 * Typeahead component for searching for Brands
 * @component
 */
class BrandSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedIds: [],
        };
        this.ref = createRef();
    }

    handleSearch = (query) => {
        this.setState({
            isLoading: true,
        });
        BrandService.typeahead(query, this.props.organization).then(
            (options) => {
                if (options === null) {
                    // this request was canceled due to a change in the typeahead component
                    return;
                }

                const list =
                    this.props.skip.length > 0
                        ? options.filter(
                              (row) => this.props.skip.indexOf(row.id) === -1
                          )
                        : options;

                this.setState({
                    isLoading: false,
                    options: this.props.multiple
                        ? list.filter(
                              (option) =>
                                  this.state.selectedIds.indexOf(option.id) ===
                                  -1
                          )
                        : list,
                });
            }
        );
    };

    /**
     * AsyncTypeahead seems to have a bug which is allowing the same option to be selected multiple times
     * so we need to keep track of the selected values uppon selection to get ride of the duplicates
     */
    handleOnChange = (selected) => {
        this.setState(
            {
                selectedIds: selected.map((option) => option.id),
                options: [],
            },
            () => {
                this.props.onChange(selected);
            }
        );
    };

    clear = () => {
        this.ref.current.clear();
        this.setState({ selectedIds: [] });
    };

    render() {
        const filterBy = () => true;
        const onChange = this.props.multiple
            ? this.handleOnChange
            : this.props.onChange;

        return (
            <AsyncTypeahead
                {...this.state}
                ref={this.ref}
                filterBy={filterBy}
                labelKey="name"
                id="brand-search"
                maxResults={10}
                minLength={2}
                multiple={this.props.multiple}
                onSearch={this.handleSearch}
                onChange={onChange}
                disabled={this.props.disabled}
                onFocus={this.props.onFocus}
                defaultSelected={this.props.defaultSelected}
                selected={this.props.selected}
                placeholder="Search for a brand..."
                renderMenuItemChildren={(option) => (
                    <div
                        key={`m${option.id}`}
                        className={`brandActive${option.active} ${
                            option.pdlt ? "brandPDLT" : ""
                        }`}
                    >
                        <span className="colHead">id:</span>
                        <span className="colValue">{option.id}</span>
                        <span className="colHead">name:</span>
                        <span className="colValue">
                            {option.name}
                            {option.pdlt === 1 ? " (PDLT)" : ""}
                        </span>
                        <span className="colHead">organization:</span>
                        <span className="colValue">{option.organization}</span>
                    </div>
                )}
                useCache={false}
            />
        );
    }
}

BrandSearch.propTypes = {
    /**  */
    onChange: PropTypes.func.isRequired,
    skip: PropTypes.arrayOf(PropTypes.number),
    organization: PropTypes.number,
    disabled: PropTypes.bool,
    selected: PropTypes.arrayOf(PropTypes.object),
    onFocus: PropTypes.func,
    multiple: PropTypes.bool,
};

BrandSearch.defaultProps = {
    onChange: (values) => {
        console.log("Brand has changed", values);
    },
    skip: [],
    organization: null,
    disabled: false,
    selected: null,
    onFocus: () => {},
    multiple: false,
};

export default BrandSearch;
